import { __extends } from "tslib";
import { deserializeAws_json1_1CreateCollectionCommand, serializeAws_json1_1CreateCollectionCommand } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var CreateCollectionCommand = /** @class */ (function (_super) {
    __extends(CreateCollectionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateCollectionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    CreateCollectionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateCollectionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1CreateCollectionCommand(input, context);
    };
    CreateCollectionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1CreateCollectionCommand(output, context);
    };
    return CreateCollectionCommand;
}($Command));
export { CreateCollectionCommand };
//# sourceMappingURL=CreateCollectionCommand.js.map